export const GenderTypeOptions =
  { male: 'Masculino',
  female: 'Feminino' };

export default GenderTypeOptions;
